import React, { useState, useRef } from 'react';
import { updateUserPassword, updateSettings } from './../../apis/services';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useTranslation } from 'react-i18next';
import { InputSwitch } from 'primereact/inputswitch';
import store from '../../redux/store';
const QAProfile = () => {
    const settings = store.getState().app.user.settings;
    const toastRef = useRef();
    const { t } = useTranslation();
    const [currentPassword, setCurrentPassword] = useState();
    const [newPassword, setNewPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();
    const [loading, setLoading] = useState(false);

    const [enableHWApprovals, setEnableHWApprovals] = useState(settings.enable_hw_approvals === 1);
    const [enableAnsApprovals, setEnableAnsApprovals] = useState(settings.enable_hw_ans_approvals === 1);

    const handleUpdateUserPassword = async () => {
        try {
            if (newPassword !== confirmPassword) {
                toastRef.current.show({ severity: 'error', summary: t('error'), detail: t('passwords_not_matching'), life: 3000 });
            } else {
                let data = {
                    newPassword: newPassword,
                    currentPassword: currentPassword
                }
                const res = await updateUserPassword(data);
                if (res.data.status) {
                    toastRef.current.show({ severity: 'success', summary: t('success'), detail: t('password_changed'), life: 3000 });
                } else {
                    toastRef.current.show({ severity: 'error', summary: t('error'), detail: t('password_change_error'), life: 3000 });
                }
            }

        } catch (error) {
            console.log(error);
        }
    }
    const handleUpadteSettings = async () =>{
        try {
            setLoading(true);
            let data={
                enableAnsApprovals:enableAnsApprovals,
                enableHWApprovals:enableHWApprovals
            }
            await updateSettings(data);
            setLoading(false);
            
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }
    return (
        <div className="p-3">
            <Toast ref={toastRef} />
            <div className="row">
                <div className="col-md-6 mt-3">
                    <div className="glass-card p-3">
                        <h4>{t('qa_profile')}</h4>
                        <form action=""
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleUpdateUserPassword();
                            }}
                        >
                            <div className="form-group">
                                <label htmlFor="currentPassword" className='required mb-1'>{t('current_password')}</label>
                                <input type="password" name="currentPassword" id="currentPassword" required className='form-control'
                                    value={currentPassword}
                                    onChange={(e) => {
                                        setCurrentPassword(e.target.value)
                                    }}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="newPassword" className='required mb-1'>{t('new_password')}</label>
                                <input type="password" name="newPassword" id="newPassword" required className='form-control'
                                    value={newPassword}
                                    onChange={(e) => {
                                        setNewPassword(e.target.value)
                                    }}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="confirmPassword" className='required mb-1'>{t("confrim_password")}</label>
                                <input type="password" name="confirmPassword" id="confirmPassword" required className='form-control'
                                    value={confirmPassword}
                                    onChange={(e) => {
                                        setConfirmPassword(e.target.value)
                                    }}
                                />
                            </div>
                            <div className="form-group mt-4">
                                <Button label={t('update')} className='p-btn' />
                            </div>
                        </form>
                    </div>
                </div>
                <div className="col-md-6 mt-3">
                    <div className="glass-card p-3 mt-3">
                        <div className="d-flex jscb">
                            <h6>{t('enable_hw_approvals')}</h6>
                            <InputSwitch checked={enableHWApprovals}
                                onChange={(e) => {
                                    setEnableHWApprovals(!enableHWApprovals);
                                }}
                            />
                        </div>
                        <div className="d-flex jscb mt-3">
                            <h6>{t('enable_hw_ans_approvals')}</h6>
                            <InputSwitch checked={enableAnsApprovals}
                                onChange={(e) => {
                                    setEnableAnsApprovals(!enableAnsApprovals);
                                }}
                            />
                        </div>
                        <div className="py-4">
                            <Button label={t('save')} className='rounded-btn' loading={loading} 
                                onClick={()=>{
                                    handleUpadteSettings();
                                }}
                            />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
export default QAProfile;